import React from "react"
import PropTypes from "prop-types"
import Section from "components/Section"
import ColorsSection from "sections/ColorsSection"
import TypographySection from "sections/TypographySection"
import TypefacesSection from "sections/TypefacesSection"
import LogosSection from "sections/LogosSection"
import IconsSection from "sections/IconsSection"
import Typography from "@material-ui/core/Typography"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import { withStyles } from "@material-ui/core/styles"

const styles = theme => ({
	root: {
		display: "flex",
		backgroundColor: theme.palette.gray.default,
		height: "100%",
		width: "100%"
	},
	menu: {
		backgroundColor: theme.palette.gray.dark,
		minWidth: 350,
		display: "flex",
		flexDirection: "column",
		overflow: "scroll",
		[theme.breakpoints.down ("sm")]: {
			display: "none"
		}
	},
	item: {
		color: theme.palette.gray.contrastText,
		opacity: 0.8,
		padding: `0 ${theme.spacing ( 6 )}px`
	},
	list: {
		marginTop: theme.spacing ( 2 ),
		flexGrow: 1,
	},
	sections: {
		width: "100%",
		flexGrow: 1,
		overflow: "scroll",
		overflowScrolling: "touch"
	},
	title: {
		color: theme.palette.gray.contrastText,
		padding: `${theme.spacing ( 8 )}px ${theme.spacing ( 8 )}px 0`,
	},
	subtitle: {
		color: theme.palette.gray.contrastText,
		opacity: 0.5,
		textTransform: "uppercase",
		padding: `${theme.spacing ( 1 )}px ${theme.spacing ( 8 )}px`
	},
	copyright: {
		width: "100%",
		padding: `${theme.spacing ( 2 )}px`,
		textAlign: "center",
		color: theme.palette.gray.contrastText,
		opacity: 0.5
	},
	mobile: {
		display: "none",
		padding: theme.spacing ( 4 ),
		background: theme.palette.gray.dark,
		color: theme.palette.gray.contrastText,
		alignItems: "center",
		"& > *:nth-child( n + 2 )": {
			textAlign: "right",
			flexGrow: 1
		},
		[theme.breakpoints.down ("sm")]: {
			display: "flex"
		}
	}
})

class StyleGuide extends React.Component {

	constructor ( props ) {
		super ( props )
		this.state = {
			hash: window.location.hash.replace ( /^#/m, "" )
		}
	}

	createMenuItem ( value ) {
		const { classes } = this.props
		const { hash } = this.state
		return <ListItem
			button selected={hash === value.toLowerCase ()}
			onClick={() => this.scrollToSection ( value.toLowerCase () )} >
			<ListItemText classes={{ root: classes.item }} >
				{value}
			</ListItemText>
		</ListItem>
	}

	scrollToSection ( hash ) {
		const sectionsContainer = document.querySelector ("#sections")
		const sections = [...document.querySelectorAll ("section")]
		const section = sections.find ( s => s.id === hash )
		sectionsContainer.scrollTop += section.getBoundingClientRect ().top,
		this.setState ({ hash })
	}

	onScroll ( event ) {
		const sectionsContainer = document.querySelector ("#sections")
		const sections = [...document.querySelectorAll ("section")]
		const first = sections [ 0 ]
		const last = sections [ sections.length - 1 ]
		const selection = sections.findIndex (
			e => e.getBoundingClientRect ().top > 0
		)
		const current = sections [ selection - 1 ] ||
			( sectionsContainer.scrollTop < 95 ? first : last )
		const hash = current.id
		if ( window.location.hash !== `#${hash}` ) {
			history.replaceState (
				null, null, `${document.location.pathname}#${hash}`
			)
			this.setState ({ hash })
		}
	}

	componentDidMount () {
		window.addEventListener ( "hashchange", () => {}, false )
		document.querySelector ("#sections").addEventListener (
			"scroll",
			this.onScroll.bind ( this ),
			false
		)
		if ( window.location.hash !== "" ) {
			this.scrollToSection ( window.location.hash.replace ( /^#/, "" ) )
		}
	}

	componentWillUnmount () {
		document.querySelector ("#sections").removeEventListener (
			"scroll",
			this.onScroll.bind ( this ),
			false
		)
	}

	render () {
		const { classes, theme } = this.props
		return <div className={classes.root} >
			<div className={classes.menu} >
				<Typography
					variant="h5"
					color="inherit"
					className={classes.title} >
					Style Guide
				</Typography>
				<Typography
					variant="body2"
					color="inherit"
					className={classes.subtitle} >
					{theme.domain}
				</Typography>
				<List className={classes.list} >
					{this.createMenuItem ( "Colors" )}
					{this.createMenuItem ( "Logos" )}
					{this.createMenuItem ( "Icons" )}
					{this.createMenuItem ( "Typefaces" )}
					{this.createMenuItem ( "Typography" )}
				</List>
				<Typography className={classes.copyright} variant="caption" >
				{
					theme.copyright
						.replace ( /<YEAR>/g, new Date ().getFullYear () )
						.replace ( /<DOMAIN>/g, theme.domain )
						.toUpperCase ()
				}
				</Typography>
			</div>
			<div id="sections" className={classes.sections} >
				<div className={classes.mobile} >
					<Typography color="inherit" variant="h5" >
						Style Guide
					</Typography>
					<Typography color="inherit" variant="subtitle1" >
						{theme.domain.toUpperCase ()}
					</Typography>
				</div>
				<ColorsSection/>
				<LogosSection/>
				<IconsSection/>
				<TypefacesSection/>
				<TypographySection/>
			</div>
		</div>
	}

}

StyleGuide.propTypes = {
	classes: PropTypes.object.isRequired
}

export default withStyles ( styles, { withTheme: true } ) ( StyleGuide )
